import React from "react";
import { useFilePicker } from "use-file-picker";
import {
  FileAmountLimitValidator,
  FileTypeValidator,
  FileSizeValidator,
} from "use-file-picker/validators";

const usePicker = (onPicked, onError, accept = [".jpg", ".png", ".jpeg"]) => {
  const { openFilePicker, filesContent, loading } = useFilePicker({
    accept: accept,
    readAs: "DataURL",
    validators: [
      new FileAmountLimitValidator({ max: 1 }),
      new FileTypeValidator(accept.map((e) => e.replace(".", ""))),
      new FileSizeValidator({ maxFileSize: 50 * 1024 * 1024 /* 50 MB */ }),
    ],
    multiple: false,

    onFilesRejected: ({ errors }) => {
      if (onError) {
        onError(errors);
      }
    },

    onFilesSuccessfullySelected: ({ plainFiles, filesContent }) => {
      if (onPicked) {
        onPicked({ plainFiles, filesContent });
      }
    },
  });

  return { openFilePicker, filesContent, loading };
};

export default usePicker;
